import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { SpaCardGrid } from "@/components/spa/SpaCard";
import EmptyState from "@/components/states/EmptyState";
import { SpaGridSkeleton } from "@/components/states/LoadingSkeletons";
import api from "@/lib/api";

export default function SeoCategory() {
  const { category } = useParams();
  const decoded = decodeURIComponent(category);
  const [data, setData] = useState(null);

  useEffect(() => {
    document.title = `${decoded} in Pune - Pune Spa Guide`;
    setData(null);
    api.get(`/seo/category/${encodeURIComponent(decoded)}`).then((r) => setData(r.data)).catch(() => setData({ items: [] }));
  }, [category, decoded]);

  return (
    <div data-testid="seo-category-page">
      <section className="hero-gradient noise-overlay">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-[rgba(201,168,106,0.4)] text-xs text-[#7A5A22] mb-4">
            <Sparkles size={14} /> Category
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl text-[#111827] tracking-tight">
            <span className="text-[#1F4E3D]">{decoded}</span> in Pune & PCMC
          </h1>
          <p className="mt-3 text-base text-[#4B5563] max-w-2xl leading-relaxed">
            Browse the best {decoded.toLowerCase()} listings across Pune and PCMC. Verified spas, transparent pricing, and direct contact.
          </p>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {data === null ? <SpaGridSkeleton count={6} /> : data.items.length === 0 ? (
          <EmptyState title={`No ${decoded} listings yet`} description="Try a different category." />
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {data.items.map((s) => <SpaCardGrid key={s.id} spa={s} />)}
          </div>
        )}
      </section>
    </div>
  );
}
